import { combineReducers } from 'redux'
import list from './list'
import setup from './setup'
import preview from './preview'
import drawer from './drawer'
import upload from './upload'
import thumbnails from './thumbnails'

export default combineReducers({
  list,
  setup,
  preview,
  drawer,
  upload,
  thumbnails,
})
